<template>
    <div>
        <div class="mb-3">
            <input
                style="width: 100%;"
                type="text"
                v-model="filterTerm"
                class="form-control"
                placeholder="Search company"
            />
        </div>
        <div class="listContainer">
            <div
                v-for="(item, index) in filteredList"
                :key="index"
                class="item"
                @click="handleShowModal(item)"
            >
                {{ item.company }}
            </div>
        </div>

        <div class="modal" id="myModal" tabindex="-1" role="dialog">
            <div
                class="modal-dialog modal-lg modal-dialog-centered"
                role="document"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ selectedCompany.company }}
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row" v-if="selectedCompany">
                            <div class="col-6">
                                <div
                                    v-for="(item,
                                    index) in selectedCompany.users"
                                    :key="index"
                                >
                                    {{ item.firstname }} {{ item.lastname }} -
                                    <span style="font-weight: bold;">{{
                                        item.pro == 1 && item.super_pro == 0
                                            ? __("traductionview.poc")
                                            : item.super_pro == 1
                                            ? "HQ"
                                            : item.super_admin == 1
                                            ? "SUPER ADMIN"
                                            : item.admin == 1
                                            ? "ADMIN"
                                            : item.manager == 1
                                            ? __("traductionview.staf")
                                            : __("traductionview.ben")
                                    }}</span>
                                </div>
                            </div>
                            <div
                                class="col-6 d-flex align-items-center justify-content-center"
                            >
                                <form
                                    class="d-flex align-items-center justify-content-center flex-column w-100"
                                    style="gap: 10px"
                                    method="POST"
                                    :action="route"
                                >
                                    <input
                                        type="hidden"
                                        name="_token"
                                        :value="token"
                                    />
                                    <label
                                        for="selectInput"
                                        style="font-weight: bold; margin-bottom: 0px;"
                                    >
                                        Choose New HQ
                                    </label>
                                    <select id="selectInput" name="hq">
                                        <option
                                            v-for="(option,
                                            index) in selectedCompany.users"
                                            :key="index"
                                            :value="option.id"
                                        >
                                            {{ option.firstname }}
                                            {{ option.lastname }}
                                        </option>
                                    </select>
                                    <button
                                        type="submit"
                                        class="btn btn-primary"
                                    >
                                        Soumettre
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["clients", "route"],
    data() {
        return {
            filterTerm: "",
            showModal: false,
            modalTitle: "",
            selectedCompany: [],
            token: document.head.querySelector('meta[name="csrf-token"]')
                .content
        };
    },
    computed: {
        filteredList() {
            return this.clients.filter(item => {
                return item.company
                    .toLowerCase()
                    .includes(this.filterTerm.toLowerCase());
            });
        }
    },
    methods: {
        handleShowModal(item) {
            this.selectedCompany = item;
            $("#myModal").modal("show");
        }
    }
};
</script>
<style lang="scss" scoped>
.listContainer {
    .item {
        &:hover {
            font-weight: bold;
            cursor: pointer;
        }
    }
}

.modal {
    padding-left: 240px !important;
}
</style>
